<template>
  <v-app-bar color="primary" dark flat>

    <!--    <v-app-bar-nav-icon />-->

    <v-toolbar-title>
      AudioButton Manager
    </v-toolbar-title>

    <v-spacer />

    <div class="mr-5"><v-icon icon="mdi-account-badge" />&nbsp;{{ user }}</div>

    <template #extension>
      <v-tabs
        v-model="currentRoutePath"
        align-tabs="title"
        fixed-tabs
      >
        <v-tab
          v-for="item in navItems"
          :key="item.id"
          :text="item.title"
          :to="item.props.to"
          :value="item.props.to"
          @click="onNavClick(item)"
        />
      </v-tabs>
    </template>
  </v-app-bar>

</template>

<script lang="ts" setup>
  import { computed, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { useAppStore } from '@/stores/app.ts'
  import { useAuthStore } from '@/stores/auth.ts'

  const route = useRoute()
  const appStore = useAppStore()
  const authStore = useAuthStore()
  const user = ref<string>(authStore.getDisplayName)

  const currentRoutePath = computed(() => route.path)

  interface NavItem {
    id: string
    title: string
    props: {
      to: string
      prependIcon?: string
    }
    requireAdmin?: boolean
  }

  const allNavItems: NavItem[] = [
    {
      id: 'buttons-list',
      title: 'Mes boutons',
      props: {
        to: '/devices',
        prependIcon: 'mdi-view-list',
      },
    },
    // {
    //   id: 'buttons-list',
    //   title: 'Mes groupes familiaux',
    //   props: {
    //     to: '/familygroups',
    //     prependIcon: 'mdi-view-list',
    //   },
    // },
    {
      id: 'system-sounds',
      title: 'System sounds',
      props: {
        to: '/system-sounds',
        prependIcon: '',
      },
      requireAdmin: true,
    },
  ]

  const isAdmin = computed(() => authStore.isAdmin)

  const navItems = computed(() => {
    return allNavItems.filter(item => {
      if (item.requireAdmin) {
        return isAdmin.value
      }
      return true
    })
  })

  function onNavClick (item: NavItem) {
    if (item.props.to === '/devices') {
      appStore.openDevicesDrawer()
    }
  }

</script>
